import { ISelectedDateRangeString, ITabData } from '../../Component/DataGrid/Interface';
import { FXReportsPermissions } from "../../Component/Permissions/PermissionsInterface.";
import { TableColumn } from 'react-data-table-component';
import { ReportsStateCommon } from '../../Component/Reusables/Utility';

export enum TabsFXReports {
    Inventory,
    Profitability,
    PoolDepletion,
    PlaceholderAllocation,
    InventoryAdjustment
}
//string enums cannot be reverse mapped, so there is no option, but to create duplicate enum to hold names
export enum TabsFXReportsNames {
    Inventory = "FX Inventory",
    Profitability = "Profitability",
    PoolDepletion = "Pool Depletion",
    PlaceholderAllocation = "Placeholder Allocation",
    InventoryAdjustment = "Inventory Adjustment"
}
export enum TabsFXReportsWidths {
    Inventory = 150,
    Profitability = 150,
    PoolDepletion = 170,
    PlaceholderAllocation = 250,
    InventoryAdjustment = 220
}
export interface IFXReportsPermissions {
    [TabsFXReports.Inventory]?: IFXReportPermissions;
    [TabsFXReports.Profitability]?: IFXReportPermissions;
    [TabsFXReports.PoolDepletion]?: IFXReportPermissions;
    [TabsFXReports.PlaceholderAllocation]?: IFXReportPermissions;
    [TabsFXReports.InventoryAdjustment]?: IFXReportPermissions;
}

export interface ITableColumns {
    [TabsFXReports.Inventory]?: TableColumn<IFXPoolDetails>[];
    [TabsFXReports.Profitability]?: TableColumn<IProfitabilityDetails>[];
    [TabsFXReports.PoolDepletion]?: TableColumn<IPoolDepletionDetails>[];
    [TabsFXReports.PlaceholderAllocation]?: TableColumn<IPlaceholderAllocationDetails>[];
    [TabsFXReports.InventoryAdjustment]?: TableColumn<IInventoryAdjustmentDetails>[];
}

export interface IFXReportPermissions {
    isVisible: boolean;
    isDownloadVisible: boolean;
}

export interface IPoolDepletionDetails {
    poolName: string;
    tradeDate: string;
    settlementDate: string;
    fromCurrency: string;
    toCurrency: string;
    exchangeRate: number;
    amount: number;
    amountUSD: number;
    fromCurrencySymbol: string;
    fromCurrencyEntity: string;
    toCurrencySymbol: string;
    toCurrencyEntity: string;
}

export interface IProfitabilityDetails {
    poolId: string;
    currency: string;
    corridor: string;
    liquidityPartner: string;
    payoutPartner: string;
    status: string;
    margin: number;
    currencySymbol: string;
    currencyEntity: string;
    sourceCurrency: string;
    targetCurrency: string;
    estimatedCostUsd: string;
    totalCostUsd: string;
    payoutPartners: string;
}

export interface IPlaceholderAllocationDetails {

}
export enum ColumnsFXPoolDetails {
    liquidityPartnerId = 'liquidityPartnerId',
    liquidityPartner = 'liquidityPartner',
    poolId = 'poolId',
    tradeDate = 'tradeDate',
    settlementDate = 'settlementDate',
    usdCurrencyRate = 'usdCurrencyRate',
    fromCurrencyRate = 'fromCurrencyRate',
    toCurrencyRate = 'toCurrencyRate',
    currencySpent = 'currencySpent',
    amountSpent = 'amountSpent',
    currencyObtained = 'currencyObtained',
    amountObtained = 'amountObtained',
    targetCountryCorridor = 'targetCountryCorridor',
    payoutPartner = 'payoutPartner',
    totalAllocatedAmount = 'totalAllocatedAmount',
    totalReversedAmount = 'totalReversedAmount',
    effectiveRemainingBalance = 'effectiveRemainingBalance',
    proofOfPurchaseLocation = 'proofOfPurchaseLocation',
    poolStatus = 'poolStatus',
    fromCurrencySymbol = 'fromCurrencySymbol',
    fromCurrencyEntity = 'fromCurrencyEntity',
    toCurrencySymbol = 'toCurrencySymbol',
    toCurrencyEntity = 'toCurrencyEntity'
}

export interface IFXPoolDetails {
    liquidityPartnerId?: number;
    liquidityPartner?: string;
    poolId?: string;
    tradeDate: string;
    settlementDate: string;
    notes: string;
    usdCurrencyRate: number;
    fromCurrencyRate?: number;
    toCurrencyRate: number;
    currencySpent: string;
    amountSpent: number;
    currencyObtained: string;
    amountObtained?: number;
    targetCountryCorridor: string;
    payoutPartner?: string;
    totalAllocatedAmount?: string;
    totalReversedAmount?: number;
    effectiveRemainingBalance?: number;
    poolStatus?: string;
    proofOfPurchaseLocation: string;
    fromCountryId: string;
    fromCurrencySymbol?: string;
    fromCurrencyEntity?: string;
    toCountryId: string;
    toCurrencySymbol?: string;
    toCurrencyEntity?: string;

    poolName?: string;
    designatedPayoutPartnerId?: string;
    poolStatusId?: string;
    designatedPayoutPartnerIds?: string;
    designatedPayoutPartnerNames?: string;
}

export interface IInventoryAdjustmentDetails {

}
export interface FXReportsState extends ReportsStateCommon {
    data: IFXReportsDetails[];
    csvData: IFXReportsDetails[];
    tabData: ITabData[];
    fxReportsSettings?: FXReportsPermissions;
    selectedTab: TabsFXReports;
    isDrawerOpen: boolean;
    appliedFiltersCount: number;
    countryId: string;
}

export interface FXReportsSettingsProps {
    userId: string;
    accessToken: string
    onValidationChange?: (hasErrors: boolean) => void;
    onClose?: (state: boolean, action: string) => void;
}


export interface FXReportsProps {

}

export type IFXReportsDetails = IPoolDepletionDetails | IProfitabilityDetails | IInventoryAdjustmentDetails | IFXPoolDetails | IPlaceholderAllocationDetails;
